<template>
  <v-app style="background-color:white;margin-top:0px">
     <go-top></go-top>
     <div style="padding-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Testimonials</span></p>
     </div>
     
     

     <div class="container">
         <h2 style="text-align:center;font-weight:bold;" class="txt">What's clients say about us</h2>
         <p style="text-align:center" class="txt">People love our products and 70% our customers are returned customers. We believe that only</p>
         <p style="text-align:center;margin-top:-20px;padding-bottom:30px" class="txt">way to make a long-term business is helping people.</p>
         <carousel v-if="list.length>0" :autoplay="true" :items="3" :nav="false" :dots="true" style="margin-top:-20px" class="res">
             <div v-for="(item, index) in list" :key="item.id">
              <v-card class="kolkata4" flat style="margin:15px" v-if="(index+1)%2!=0" >
                 <div class="container" >
                     <h4 style="font-weight:bold" class="txt">{{item.title}}</h4>
                     <p class="txt"> {{item.message}}</p>
                     <v-layout row wrap>
                 <v-flex xs4 sm4 md2>
                   <v-avatar style="cursor:pointer;text-align:right">
                    <img v-if="item.src==null" class="center" src="../../assets/default-user.png" style="border: 1px solid; border-color:grey" />
                    <img v-if="item.src!=null" class="center" :src=item.src style="border: 1px solid; border-color:grey" />
                  </v-avatar>
                 </v-flex>
                 <v-flex xs8 sm8 md10 style="padding-left:10px">
                   <h6 class="txt" style="font-weight:bold;margin-top:10px;margin-bottom:0px">{{item.customerName}}</h6>
                   <span class="txt" style="margin-top:-5px;color:white;">{{item.address}}</span>
                 </v-flex>
               </v-layout>
                 </div>
              </v-card>
              <v-card class="kolkata5" flat style="margin:15px" v-if="(index+1)%2==0" >
                 <div class="container" >
                     <h4 style="font-weight:bold" class="txt">{{item.title}}</h4>
                     <p class="txt"> {{item.message}}</p>
                     <v-layout row wrap>
                 <v-flex xs4 sm4 md2>
                   <v-avatar style="cursor:pointer;text-align:right">
                    <img v-if="item.src==null" class="center" src="../../assets/default-user.png" style="border: 1px solid; border-color:grey" />
                    <img v-if="item.src!=null" class="center" :src=item.src style="border: 1px solid; border-color:grey" />
                  </v-avatar>
                 </v-flex>
                 <v-flex xs8 sm8 md10 style="padding-left:10px">
                   <h6 class="txt" style="font-weight:bold;margin-top:10px;margin-bottom:0px">{{item.customerName}}</h6>
                   <span class="txt" style="margin-top:-5px;color:white;">{{item.address}}</span>
                 </v-flex>
               </v-layout>
                 </div>
              </v-card>
             </div>
             
         </carousel>

         <carousel :autoplay="true" :items="1" :nav="false" :dots="true" style="margin-top:-20px" class="man">
             <v-card flat style="background-color:#F0F3F9;margin:15px" v-for="item in list" :key="item.id">
                 <div class="container">
                     <h4 style="font-weight:bold" class="txt">{{item.title}}</h4>
                     <p class="txt"> {{item.message}}</p>
                     <v-layout row wrap>
                 <v-flex xs4 sm4 md2>
                   <v-avatar style="cursor:pointer;text-align:right">
                    <img v-if="item.src==null" class="center" src="../../assets/default-user.png" style="border: 1px solid; border-color:grey" />
                    <img v-if="item.src!=null" class="center" :src=item.src style="border: 1px solid; border-color:grey" />
                  </v-avatar>
                 </v-flex>
                 <v-flex xs8 sm8 md10 style="padding-left:10px">
                   <h6 class="txt" style="font-weight:bold;margin-top:10px;margin-bottom:0px">{{item.customerName}}</h6>
                   <span class="txt" style="margin-top:-5px;color:white;">{{item.address}}</span>
                 </v-flex>
               </v-layout>
                 </div>
             </v-card>
         </carousel>
     </div>
  </v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import config from "./../../config.json";
import GoTop from '@inotom/vue-go-top';
import carousel from 'vue-owl-carousel';

export default {
  components: {
    GoTop,
    carousel
  },
  data() {
    return {
      valid: true,
      list: [
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        },
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        },
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        },
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        },
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        },
        {
          title: "Hello",
          message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
          src: null,
          customer: "Hello",
          address: "Hello world"
        }
      ],
      isLoading: false,
      text: null,
      read: false,

      form: {},

      
    };
  },
  
   mounted() {
   },

 methods: {
     home(){
         this.$router.push(`/worldwin`);
     }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.kolkata4 {
    background-image: linear-gradient(to bottom,rgba(221, 114, 42, 0.73), rgba(54, 34, 20, 0.73)), url('../../assets/admission.jpg');
    background-size: cover;
    color: white !important;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/popular_course.jpg');
    background-size: cover;
    color: white !important;
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #3486D7 !important;
}
</style>
